import axios from '@/util/axios'
import axiosNoError from '@/util/axios_no_error'
import { API_RELAY_PATH } from '@/util/constants'
import { isFromAdminSystem } from '@/util/common'
import store from '@/store'

/**
 * GA送信情報取得(設問)API
 * @param  {} params={}
 */
export const gaQaInfo = (params = {}) => {
  const defaults = {
    _path: 'GA/001',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}

/**
 * GA送信情報取得(最新ナレッジ)API
 * @param  {} params={}
 */
export const productCodes = (params = {}) => {
  const defaults = {
    _path: 'GA/002',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  if (isFromAdminSystem()) {
    return axiosNoError.post(API_RELAY_PATH, r)
  } else {
    return axios.post(API_RELAY_PATH, r)
  }
}
